<template>
    <div>
        <date-picker
            id="datepickerRequestsPerTimeframe"
            @apply="onDateChange"
            @loaded="onDatePickerLoaded"
            :mode="'statistics'"
            :presetTimes="form.dates"
            :disabled="formdisabled"
        ></date-picker>
        <Chart ref="chart">
            <ChartTitle :text="this.$t('statistics.orders-per-period')" />
            <ChartTooltip />
            <ChartCategoryAxis>
                <ChartCategoryAxisItem
                    :title="{
                                                                text: this.$t('statistics.months'),
                                                              }"
                    :categories="categories"
                />
            </ChartCategoryAxis>
            <ChartSeries>
                <ChartSeriesItem
                    :type="'column'"
                    :color="'green'"
                    :data-items="firstSeries"
                >
                    <ChartSeriesItemTooltip :background="'lightgray'" />
                </ChartSeriesItem>
            </ChartSeries>
        </Chart>
        <kbutton @click="onImageExportClick">{{this.$t("statistics.save-as-image")}}</kbutton>
    </div>
</template>

<script>
import {
    Chart,
    ChartTitle,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisTitle,
    ChartCategoryAxisItem, ChartTooltip, ChartSeriesItemTooltip, exportVisual,
} from "@progress/kendo-vue-charts";
import "hammerjs";
import { DateRangePicker } from '@progress/kendo-vue-dateinputs';
import {Button} from "@progress/kendo-vue-buttons";
import zipcelx from "zipcelx";
import {process} from "@progress/kendo-data-query";
import {exportImage} from "@progress/kendo-drawing";

export default {
    name: "OrdersPerTimeFrame",
    components:{
        Chart,
        ChartTooltip,
        ChartTitle,
        ChartSeries,
        ChartSeriesItem,
        ChartSeriesItemTooltip,
        ChartCategoryAxis,
        ChartCategoryAxisTitle,
        ChartCategoryAxisItem,
        DateRangePicker,
        kbutton: Button,
    },
    data() {
        return {
            activeChart: 'countRentsPerDateRange',

            firstSeries: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            categories: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],

            defaultShow: false,
            formdisabled: false,
            form:{
                from: moment().startOf('year'),
                until: moment().endOf('year'),
                dates:{
                    from: moment().startOf('year'),
                    until: moment().endOf('year'),
                }
            },
        };
    },
    computed: {
        getPresetTimes(){
            console.log("form-order: getPresetTimes", {from: this.form.from, until: this.form.until});
            if(this.presetdata != undefined && this.presetdata !== false && this.presetdata.hasOwnProperty("startDate") && this.presetdata.hasOwnProperty("endDate")){
                return {
                    from: moment.parseZone(this.presetdata.startDate),
                    until: moment.parseZone(this.presetdata.endDate),
                };
            }else{
                console.log("retuning safe last year");
                return {from: this.form.from, until: this.form.until};
            }
        },
    },
    mounted(){
    },
    methods:{
        onDatePickerLoaded: function (dates) {
            console.log("Picker loaded with dates", dates);

            /*
            this.form.dates = dates;
            this.form.from = dates.from;
            this.form.until = dates.until;*/

            //this.loadData(this.getPresetTimes);
            this.loadData(this.form.dates);
        },

        loadData: function (dates){


            axios
                .get('/api/statistics/getOrdersPerTimeframe', {
                    params: {
                        dateStart: dates.from.toString(),
                        dateEnd: dates.until.toString()
                    }
                })
                .then(response => {
                    console.log("response");
                    console.log(response);



                    let myKeys = Object.keys(response.data);

                    this.categories = [];
                    this.firstSeries = [];

                    myKeys.forEach((key, index) => {
                        //console.log(`${key}: ${index[key]}`);
                        this.categories.push(key);
                        this.firstSeries.push(Object.keys(response.data[key]).length);
                    });



                    //this.firstSeries = Object.keys(response.data).length;

                    console.log(this.firstSeries);

                });

            /*
            this.form.dates = dates;
            this.form.from = dates.from;
            this.form.until = dates.until;


            // Nur den Object Picker neu laden, wenn auch direkt equipment gewählt werden soll
            if(this.form.request_equipment_select_type =='specific')
                this.$refs.objectpicker.reloadStore();

             */
        },

        onDateChange:  function (dates) {
            console.log("Zeitraum geändert 1", dates.from.toString());
            console.log("Zeitraum geändert 2", dates.until.toString());

            this.loadData(dates);
        },
        exportChartVisual(callback) {
            const chartVisual = exportVisual(this.$refs.chart, {});
            if (chartVisual) {
                callback(chartVisual);
            }
        },
        onImageExportClick() {
            this.exportChartVisual((chartVisual) =>
                exportImage(chartVisual).then((dataURI) => saveAs(dataURI, "chart.png"))
            );
        },
    }
}
</script>

<style scoped>

</style>
